import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import footerlogo from '../../assets/images/logoSeal.webp';
import { Link } from 'react-router-dom';
import { isIOS, isMobile, isSafari } from 'react-device-detect';

const TheFooter = () => (
  <footer>
    <Container
      className={`position-relative ${isSafari && isIOS ? 'pb-5' : ''}`}>
      <div>
        <Row className="g-2 justify-content-between">
          <Col lg={3} md={3} sm={12}>
            <div className="footer-logo">
              <img
                src={footerlogo}
                alt="The U.S. Will Registry Seal"
                width={isMobile ? 90 : 170}
                height={isMobile ? 90 : 170}
                loading="lazy"
              />
            </div>
          </Col>
          <Col lg={9} md={9} sm={12}>
            <Row>
              <Col lg={3} md={6} sm={12} className="footer-services">
                <h5 className="color-white">PLANNING TOOLS</h5>
                <ul className="list-unstyled">
                  <li>
                    <Link
                      to={`${process.env.REACT_APP_WILL_CREATION_URL}/advance-directive-forms`}
                    >
                      Advance Directive Forms
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`${process.env.REACT_APP_WILL_CREATION_URL}/faqs`}
                    >
                      FAQs
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`${process.env.REACT_APP_WILL_CREATION_URL}/terminologies`}
                    >
                      Terminology
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`${process.env.REACT_APP_WILL_CREATION_URL}/obituaries-and-death-notices/death-notices`}
                    >
                      Death Notices
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`${process.env.REACT_APP_WILL_CREATION_URL}/obituaries-and-death-notices/obituaries`}
                    >
                      Obituaries
                    </Link>
                  </li>
                </ul>
              </Col>
              <Col lg={3} md={6} sm={12} className="footer-services">
                <h5 className="color-white">ESTATE RESOURCES</h5>
                <ul className="list-unstyled">
                  <li>
                    <Link
                      to={`${process.env.REACT_APP_WILL_CREATION_URL}/estate-articles`}
                    >
                      Estate Planning Articles
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`${process.env.REACT_APP_WILL_CREATION_URL}/estate-forms`}>
                      Estate Planning Forms
                    </Link>
                  </li>
                  <li>
                    <li>
                      <Link to="https://www.sidedrawer.com/us-national-will-registry">
                        Online Will Storage
                      </Link>
                    </li>
                  </li>
                </ul>
              </Col>
              <Col lg={3} md={6} sm={12} className="footer-services">
                <h5 className="color-white">ABOUT THE REGISTRY</h5>
                <ul className="list-unstyled">
                  <li>
                    <Link
                      to={`${process.env.REACT_APP_WILL_CREATION_URL}/about-us`}
                    >
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`${process.env.REACT_APP_WILL_CREATION_URL}/contact-us`}
                    >
                      Contact Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`${process.env.REACT_APP_WILL_CREATION_URL}/testimonials`}
                    >
                      Testimonials
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`${process.env.REACT_APP_WILL_CREATION_URL}/editorial-policy`}
                    >
                      Editorial Policy
                    </Link>
                  </li>
                </ul>
              </Col>
              <Col lg={3} md={6} sm={12} className="footer-services">
                <h5 className="color-white">Legal Resources</h5>
                <ul className="list-unstyled">
                  <li>
                    <Link to="/find-an-attorney">
                      Attorney Directory
                    </Link>
                  </li>
                  <li><Link to="/attorney-registration"
                  >
                    Attorney Registration
                  </Link>
                  </li>
                  <li>
                    <Link to={`${process.env.REACT_APP_WILL_CREATION_URL}/notary`}>Get Notarized</Link>
                  </li>
                </ul>
                <h5 className="color-white mt-3">For Nonprofits</h5>
                <ul className="list-unstyled">
                  <li>
                    <Link
                      to={
                        process.env.REACT_APP_PLP_URL ??
                        'https://plannedlegacyprogram.org'
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Planned Legacy Program
                    </Link>
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <hr className="mt-8"></hr>
      <Col lg={12} md={12} sm={12}>
        <div className="footer-about">
          <span>
            The U.S. Will Registry was founded in 1997 to fill an important gap
            to provide families and other Will beneficiaries with a means to
            find lost Wills and estate planning documents of those who have
            passed away.
          </span>
        </div>
      </Col>
      <div className="copyright-detail d-flex flex-wrap align-items-center justify-content-sm-between mt-3 gap-lg-0 gap-3">
        <div className="d-flex align-items-center justify-content-center order-1 order-md-2 ordr-lg-2">
          <h4 className="color-white m-0 me-3">Connect: </h4>
          <div className="social-links">
            <Link
              to="https://www.facebook.com/profile.php?id=61560076259265"
              target="_blank"
              className="fb"
              aria-label="Facebook"
              rel="noopener noreferrer"
            >
              <span>Facebook</span>
            </Link>
            <Link
              to="https://x.com/uswillregistry"
              target="_blank"
              className="tw"
              aria-label="Twitter"
              rel="noopener noreferrer"
            >
              <span>Twitter</span>
            </Link>
          </div>
        </div>
        <p className=" order-2 order-md-1 ordr-lg-1">
          Copyright @ {new Date().getFullYear()} The U.S. Will Registry. All
          Rights Reserved.
        </p>
      </div>
    </Container>
  </footer>
);

export default TheFooter;
